import { render, staticRenderFns } from "./ContactSummary.vue?vue&type=template&id=424683ea&"
import script from "./ContactSummary.vue?vue&type=script&lang=js&"
export * from "./ContactSummary.vue?vue&type=script&lang=js&"
import style0 from "./ContactSummary.vue?vue&type=style&index=0&id=424683ea&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports